/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 14:30:38
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 11:08:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/AdvancedSettings/index.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import Table from '@/src/components/DroppableTable/DroppableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { advancedColumns } from '../config';
import css from '../css.module.less';

const AdvancedSettings = ({
  methodsList,
  enableThirdPartyCurrency,
  primaryCurrency,
  currencyCodes,
  currencyCheck,
  onTableChange,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      // containerClassName={css.invoiceFormat}
      title={getI18n(
        'salesChannelPayment.index.paymentMethodsAdvancedSettings',
      )}>
      <p>
        {getI18n(
          'salesChannelPayment.index.changethedisplayorderofeachpaymentmethod',
        )}
      </p>
      <Form.Item
        noStyle
        shouldUpdate={(p, c) =>
          p.enableProcessingFee !== c.enableProcessingFee
        }>
        {({ getFieldValue }) => (
          <Table
            id='advancedSettings'
            rowKey={(record) =>
              `${record.storeGatewayProviderUuid}-${record.paymentMethodVO.uuid}`
            }
            hideAllDragHandlers={disableEdit}
            className={css.globalStoreTable}
            columns={advancedColumns(
              enableThirdPartyCurrency,
              primaryCurrency,
              currencyCodes,
              currencyCheck,
              getFieldValue('enableProcessingFee'),
              disableEdit,
              { getI18n },
            )}
            onTableChange={onTableChange}
            dataSource={methodsList}
            pagination={false}
          />
        )}
      </Form.Item>

      <Form.Item
        name='enableProcessingFee'
        label={getI18n('salesChannelPayment.index.processingFee')}
        valuePropName='checked'
        labelCol={{ span: 24 }}>
        <Checkbox disabled={disableEdit}>
          {getI18n('salesChannelPayment.index.chargemycustomeraprocessingfee')}
        </Checkbox>
      </Form.Item>
      <Configuration
        configStart={getI18n('salesChannelPayment.index.gotoStoreSettings')}
        linkTo={`/settings/payment/list`}
        configLink={getI18n('salesChannelPayment.index.payment')}
        configEnd={getI18n(
          'salesChannelPayment.index.tosetuptheprocessingfeeofeachpaymentmethod',
        )}
      />
    </SectionWrapper>
  );
};

export default AdvancedSettings;
